import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

/**
 * Directive that activates the first tab in an iris-tab component
 * This is a workaround for a tab activation issue in Angular 17
 */
@Directive({
  selector: '[activeFirstTab]',
  standalone: false
})
export class ActiveFirstTabDirective implements AfterViewInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.activateFirstTab();
    });
  }

  private activateFirstTab(): void {
    try {
      // Find the tab container
      const tabContainer = this.el.nativeElement.querySelector('.tab-container');
      if (!tabContainer) {
        return;
      }

      // Find first tab item
      const firstTabItem = tabContainer.querySelector('a.tab-item');
      if (!firstTabItem) {
        return;
      }
      // add the active class to the first tab item
      this.renderer.addClass(firstTabItem, 'active');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error activating first tab:', error);
    }
  }
}
